import React, { useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export interface ResourceHeaderDTO {
    id: string;
    key: string;
    title: string;
    columnNumber: number;
    items: ResourceItemDTO[];
}

export interface ResourceItemDTO {
    id?: number;
    text: string;
    key?: string;
    collapsible?: boolean;
    link?: string;
    subitems?: ResourceItemDTO[];
}

interface RenderResourceSubmenuProps {
    data: ResourceItemDTO;
    namespace: string;
    classNames?: string;
}

const RenderSubmenu: React.FC<RenderResourceSubmenuProps> = ({
    data,
    namespace,
    classNames = '',
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const renderSubmenuItems = useCallback(
        (data: ResourceItemDTO, depth: number = 1) => {
            const itemId = data.id || uuidv4();

            if (!data.subitems || data.subitems.length === 0) {
                return (
                    <a
                        className="resources-subcategories pd-dark text"
                        href={data.link}
                        target="_blank"
                        style={{ paddingLeft: `${(depth + 1) * 5}px` }}
                        rel="noopener noreferrer"
                    >
                        {data.text}
                    </a>
                );
            }
            return (
                <div
                    key={`${namespace}-submenu-item-${itemId}`}
                    className="submenu-div flex"
                    style={{ flexDirection: 'column' }}
                >
                    <a
                        className={`${classNames}${isExpanded ? ' active' : ''}`}
                        href="#"
                        style={{ paddingLeft: `${(depth + 1) * 5}px` }}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? '+' : '\u2013'} {data.text}
                    </a>
                    <div
                        className="submenu-links-div"
                        style={{
                            // TODO: Check if flex is appropriate
                            display: isExpanded ? 'flex' : 'none',
                        }}
                    >
                        {data.subitems
                            ? data.subitems.map((subitem, index) => {
                                  if (subitem.subitems && subitem.subitems.length > 0) {
                                      return renderSubmenuItems(subitem, depth + 1);
                                  } else {
                                      return (
                                          <a
                                              key={`${namespace}-submenu-item-${itemId}-${index}`}
                                              className={classNames}
                                              style={{
                                                  paddingLeft: `${(depth + 2) * 10}px`,
                                              }}
                                              href={subitem.link}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                          >
                                              {subitem.text}
                                          </a>
                                      );
                                  }
                              })
                            : null}
                    </div>
                </div>
            );
        },
        [isExpanded, namespace, classNames]
    );

    return renderSubmenuItems(data, 0);
};

export default RenderSubmenu;
